import iconSelector from "./icon-selector";

export default {
  iconSelector,
};
